import { theme } from "../theme.js";
import React from "react";
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function Hero() {
  const [searchQuery, setSearchQuery] = React.useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/events?q=${encodeURIComponent(searchQuery)}`;
    }
  };

  return (
    <section style={styles.hero}>
      <div style={styles.content}>
        <h2 style={styles.tagline}>Réserve ton prochain dossard</h2>
        <p style={styles.subtitle}>
          Découvre et inscris-toi aux événements sportifs près de chez toi
        </p>
        <p style={styles.subtitle}>
          Tu ne peux plus assister à la course ? Transfère ton dossard à un ami ou revends-le en quelques clics !
        </p>
        
        {/* Search Bar */}
        <form style={styles.searchForm} onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Rechercher des courses..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={styles.searchInput}
          />
          <button type="submit" style={styles.searchButton}>
            <MagnifyingGlassIcon style={styles.icon} />
          </button>
        </form>
      </div>
    </section>
  );
}

const styles = {
  hero: {
    backgroundColor: theme.colors.bgDark,
    padding: `${theme.spacing.huge} ${theme.spacing.lg}`,
    textAlign: "center",
    minHeight: "500px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  content: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  tagline: {
    fontSize: theme.fonts.size.heroTitle,
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.light,
    margin: `0 0 ${theme.spacing.lg} 0`,
    fontFamily: theme.fonts.family.primary,
    lineHeight: "1.2",
    fontStyle: "italic",
  },
  subtitle: {
    fontSize: theme.fonts.size.xl,
    color: theme.colors.white,
    margin: `0 0 ${theme.spacing.huge} 0`,
    lineHeight: "1.6",
  },
  searchForm: {
    display: "flex",
    gap: theme.spacing.md,
    maxWidth: "600px",
    alignItems: "center",
    margin: "0 auto",
  },
  searchInput: {
    flex: 1,
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    border: `1px solid ${theme.colors.light}`,
    borderRadius: theme.radius.lg,
    fontSize: theme.fonts.size.md,
    outline: "none",
    backgroundColor: theme.colors.white,
    color: theme.colors.dark,
    transition: `border ${theme.transitions.base}`,
  },
  searchButton: {
    backgroundColor: theme.colors.light,
    border: "none",
    borderRadius: theme.radius.lg,
    padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
    cursor: "pointer",
    transition: `all ${theme.transitions.base}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    width: "30px",
    height: "30px",
    color: theme.colors.dark,
    strokeWidth: 3,
  },
};
